<template>
  <div class="cat-container" :id="cat ? cat.key : ''">
    <div v-if="catDescr || catDetail" class="cat-header">
      <div v-if="catDescr" class="-descr">{{ catDescr }}</div>
      <div v-if="catDetail" class="-detail">
        {{ catDetail }}                            
      </div>
    </div>

    <div class="item-list-box">
      <div v-if="items" class="item-list">
        <div v-for="(item, index) in items" :key="index" class="item-list-row">
          <div class="item-descr">{{ $store.getters.itemDescr(item) }}</div>
          <!--           
          <div v-if="$store.getters.itemSoldout(item)" class="item-soldout">
            <div>{{ $t("soldout") }}</div>
          </div> 
          -->

          <v-btn v-if="$store.getters.itemSoldout(item)" class="ml-auto" color="warning" rounded>{{
            $t("soldout")
          }}</v-btn>
          <v-btn v-else-if="item.orderDisabled === true" class="ml-auto" color="warning" rounded @click="callService">{{
            $t("item_call_server")
          }}</v-btn>
          <div v-else class="d-flex align-center">
            <!-- <div v-if="item.price" class="item-price">{{ item.price | currency }}</div> -->
            <div v-if="item.price" class="item-price">{{ $store.getters.itemDiscountedSub(item) | currency }}</div>
            <div v-if="
              item.itemDialog /*(item.options && item.options.length > 0) || (item.menuSchema && item.menuSchema.image)*/
            " class="order-box-1">
              <div v-if="$store.getters.orderItemQtyTotal(item) > 0" class="qty-value">
                {{ $store.getters.orderItemQtyTotal(item) }}
              </div>
              <v-btn class="ml-auto" color="primary" rounded @click="itemClicked({ item: item, orderQty: 0 })">{{
                $store.getters.padSetting.menuMode === true ? $t("view") : $t("order")
              }}</v-btn>
            </div>
            <div v-else :class="[$store.getters.padSetting.menuMode === true ? 'order-box-base' : 'order-box-2']">

                <v-icon v-if="$store.getters.padSetting.menuMode !== true" class="order-qty-button" @click="itemClicked({ item: item, orderQty: -1 })">
                  mdi-minus
                </v-icon>
                <div v-if="$store.getters.padSetting.menuMode !== true" class="qty-value">{{ $store.getters.orderItemQtyTotal(item) }}</div>
                <v-icon v-if="$store.getters.padSetting.menuMode !== true" @click="itemClicked({ item: item, orderQty: 1 })">
                  mdi-plus
                </v-icon> 

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import mDialog from "@/modules/dialog";

export default {
  props: {
    cat: null,
    showCatName: null,
  },

  computed: {
    items() {
      if (this.cat) {
        return this.cat.items.filter(
          item => item.orderTypes.includes(this.$store.state.Order.order.orderType) && !item.bItem
        );
      } else return [];
    },

    catDescr() {
      if (!this.cat) return undefined;
      if (!this.showCatName) return undefined;

      let descr = this.cat.descr;
      if (this.$store.state.descrIndex == 1 && this.cat.descr1) descr = this.cat.descr1;
      else if (this.$store.state.descrIndex == 2 && this.cat.descr2) descr = this.cat.descr2;
      return descr;
    },

    catDetail() {
      if (!this.cat) return undefined;

      let detail = this.cat.detail;
      if (this.$store.state.descrIndex == 1 && this.cat.detail1) detail = this.cat.detail1;
      else if (this.$store.state.descrIndex == 2 && this.cat.detail2) detail = this.cat.detail2;
      return detail;
    },
  },

  methods: {
    itemClicked(payload) {
      this.$emit("itemClicked", payload);
    },

    callService() {
      /*
      this.$store.dispatch("PAD_SEND_MESSAGE", "SERVICE");
      mDialog.messageDialog.open("Message was sent");
      */
    },
  },
};
</script>

<style lang="scss" scoped>
.cat-container {
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100vh - 90px - 90px);
  //background-color: rgba(0, 0, 0, 0.6);
  overflow: auto;
  //padding: 24px 24px;
  padding: 12px;
  //padding-top: 24px;

  .cat-header {
    background-color: rgba(255, 255, 255, 0.9);
    //margin: 12px 0px !important;
    margin: 0px 0px !important;
    margin-bottom: 4px !important;
    padding: 8px;
    font-size: 0.9em;

    .-descr {
      font-size: 1.2em;
      font-weight: bold;
    }

    .-detail {}
  }

  .item-list-box {
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 16px;

    .item-list {
      .item-list-row {
        height: 64px;
        color: white;

        border-bottom: solid 1px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item-descr {
          margin-right: auto;
        }

        /*
        .item-soldout {
          display: flex;
          justify-content: center;
          div {
            background-color: var(--v-warning-base);
            color: var(--v-warningText-base);
            padding: 4px 16px;
            border-radius: 18px;
            font-size: 0.8em;
            text-transform: uppercase;
          }
        }
        */
        .item-price {
          width: 80px;
          text-align: right;
        }

        .order-box-base {
          display: flex;
          align-items: center;
          justify-content: space-between;

          width: 160px;
          margin-left: 20px;
        }

        .order-box-1 {
          @extend .order-box-base;

          .qty-value {
            border-radius: 18px;
            background-color: rgb(200, 200, 200);
            color: black;
            width: 36px;
            height: 36px;
            text-align: center;
            line-height: 36px;
          }

          .v-btn {
            //border-radius: 18px;
            min-width: 100px;
            //font-size: 0.8em;
            //text-transform: unset;
          }
        }

        .order-box-2 {
          @extend .order-box-base;

          border-radius: 20px;
          background-color: rgb(200, 200, 200);
          color: black;

          padding: 4px 12px;
        }
      }
    }
  }
}
</style>
